<template>
    <div>
        <mdb-navbar class="top-nav" light>
<!--            <mdb-navbar-brand href="#">-->
<!--&lt;!&ndash;                <router-link to="/index">&ndash;&gt;-->
<!--&lt;!&ndash;                    <img :src="getCompanyLogo()" alt="Logo" class="menu_logo"/>&ndash;&gt;-->
<!--&lt;!&ndash;                </router-link>&ndash;&gt;-->
<!--            </mdb-navbar-brand>-->
            <mdb-navbar-nav>
                <mdb-nav-item class="item_title" href="#" waves-fixed><h3 style="color:grey"> {{ page_title }} </h3></mdb-nav-item>
            </mdb-navbar-nav>
            <mdb-navbar-toggler>
                <mdb-navbar-nav></mdb-navbar-nav>
                <!-- <mdb-form-inline>
                    <mdb-input   aria-label="Search"   class="mr-sm-2" id="search"
                               placeholder="Search"
                               type="text" v-bind:value="search_query" v-on:input="getSearchQuery"/>
                    <mdb-btn class="my-0"  outline="grey" size="sm" type="submit">Search
                        <i style="color: gray" aria-hidden="true" class="fas fa-search"></i></mdb-btn>
                </mdb-form-inline> -->
                <div v-if="isAuth === true">
                  <router-link to="cart-view">
                    <i  aria-hidden="true" class="fas fa-shopping-cart cart_icon"><sup style="color: black" class="cart_items_text">({{this.cartItems.length}})</sup>Cart </i>
                  </router-link>
                </div>

                <div v-if="isAuth === true">
                    <mdb-dropdown  class="nav-item item_title" tag="li">
                        <mdb-dropdown-toggle
                                navLink
                                slot="toggle"
                                tag="a"
                                waves-fixed
                        ><i  class="fas fa-user fa-2x " ></i> {{this.userName}}
                        </mdb-dropdown-toggle
                        >
                        <mdb-dropdown-menu>
                            <mdb-dropdown-item>
                                <i  class="far fa-id-badge fa-lg "></i>
                                <router-link to="user"> Profile</router-link>
                            </mdb-dropdown-item>
                            <mdb-dropdown-item>
                                <i class="fas fa-sign-out-alt fa-lg"></i>
                                <router-link @click.native="signOut" to="#"> Sign Out</router-link>
                            </mdb-dropdown-item>
                        </mdb-dropdown-menu>
                    </mdb-dropdown>
                </div>
                <div v-else-if="isAuth === false">
                    <mdb-dropdown class="nav-item item_title" disabled="true" tag="li">
                        <mdb-dropdown-toggle
                                navLink
                                slot="toggle"
                                tag="a"
                                waves-fixed

                        ><i class="fas fa-user fa-2x" ></i>
                          User
                        </mdb-dropdown-toggle>
                        <mdb-dropdown-menu>
                            <mdb-dropdown-item>
                                <router-link to="login">Login</router-link>
                            </mdb-dropdown-item>
                            <mdb-dropdown-item>
                                <router-link to="register">Sign Up</router-link>
                            </mdb-dropdown-item>
                        </mdb-dropdown-menu>
                    </mdb-dropdown>
                </div>
            </mdb-navbar-toggler>
        </mdb-navbar>
        <!-- <div style="height: 18vh">
            <div class="view intro-2">
                <div class="full-bg-img">
                    <div class="mask rgba-white-strong">
                        <div class="container flex-center">
                            <div class="dark-grey-text">
                                <h2 class="font-weight-bold">

                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import {getStoredUserDetails, isUserLoggedIn, logOutUser,} from '@/utils/util_functions';
import {
  /*mdbBtn,*/ mdbDropdown, mdbDropdownItem, mdbDropdownMenu,
  mdbDropdownToggle, /*mdbFormInline, mdbInput,*/ mdbNavbar,
   mdbNavbarNav, mdbNavbarToggler, mdbNavItem
} from 'mdbvue'
import EventBus from '@/components/EventBus';
import {getCartItems} from '@/utils/util_functions';

export default {
  name: 'top-nav',
  props: {
    page_title: {
      type: String,
      required: true,
    },
    search_query: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      userName: null,
      isAuth: null,
      // eslint-disable-next-line no-undef
      cartItems: [],
    }
  },

  mounted() {
    /* listen to the add to cart event from the ListSampleView page and DetailedSampleView
    * and update the cartItems list*/
    EventBus.$on('add-to-cart', payload => {
      this.cartItems = payload
    })
  },

  methods: {
    getCompanyLogo() {
      return require('@/assets/icipe-logo-web-200px-jpg.jpg')
    },

    getUser() {
      this.isAuth = isUserLoggedIn()
      if (this.isAuth === true) {
          let user = getStoredUserDetails()
          this.userName = user['first_name']
      } else {
          this.userName = null
      }
    },

    getSearchQuery() {
        let query = document.getElementById('search').value;
        EventBus.$emit('searchQuery', query);
    },

    signOut() {
        return logOutUser(this)
    }
  },

  components: {
      /*mdbInput,*/ mdbNavbar, mdbNavbarToggler, mdbNavbarNav, mdbNavItem,
      mdbDropdown, mdbDropdownMenu, mdbDropdownItem, mdbDropdownToggle, /*mdbFormInline,
      mdbBtn*/
  },

  created() {
      this.getUser();
      // get items in cart
      this.cartItems = getCartItems()
  }
}
</script>
